import { render, staticRenderFns } from "./BsTreegrid.vue?vue&type=template&id=24fbeda2&"
import script from "./BsTreegrid.vue?vue&type=script&lang=js&"
export * from "./BsTreegrid.vue?vue&type=script&lang=js&"
import style0 from "./BsTreegrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports